var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Sect',[_c('Wrap',{attrs:{"id":"self-project-progress"}},[_c('Timeline',{attrs:{"timeline":_vm.projectPosts}}),(!_vm.projectPosts.length)?_c('Empty',[_vm._v(" Dar nėra jokių naujienų apie projektą ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }